module.exports = __webpack_public_path__ + "static/media/icono_quiero_ser_artista.3082eaa6.svg";